import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useEffect, useRef, useState } from 'react';
import micFill from '@iconify/icons-eva/mic-fill';
import roundSend from '@iconify/icons-ic/round-send';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import roundAddPhotoAlternate from '@iconify/icons-ic/round-add-photo-alternate';
// material
import { styled } from '@material-ui/core/styles';
import { Input, Divider, IconButton, InputAdornment, Stack, Typography, Box, Paper, Chip } from '@material-ui/core';
//
import EmojiPicker from '../../EmojiPicker';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { setDayOfYear } from 'date-fns';
import useAuth from '../../../hooks/useAuth';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  maxHeight: 110,
  minHeight: 60,
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2)
}));

// ----------------------------------------------------------------------

ChatMessageInput.propTypes = {
  disabled: PropTypes.bool,
  sendToId: PropTypes.string,
  onSend: PropTypes.func
};

export default function ChatMessageInput({ user_id, disabled, sendToId, onSend, ...other }) {
  const fileInputRef = useRef(null);
  const [refValue, setRefValue] = useState([]);
  const { user } = useAuth();
  const [isShowTempFile, setIsShowTempFile] = useState(false);
  const [updateLoadFile, setUpLoadFile] = useState(false);
  const [message, setMessage] = useState('');
  const handleAttach = () => {
    fileInputRef.current.click();
    setUpLoadFile(true);
  };

  const handleChangeMessage = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      handleSend();
    }
  };

  const handleSend = async () => {
    if (!message && fileInputRef.current?.files.length === 0) {
      return '';
    }
    if (onSend) {

      const params = {
        user_id,
        contentType: 'text',
        attachments: [],
        access_token_page: "",
        user_response: user?.id
      }
      if (refValue.length > 0) {
        for (var j = 0; j < refValue.length; j++) {
          params.attachments = refValue[j];
          params.contentType = "file";
          onSend(params);
        }
      }
      if (message) {
        params.attachments = [];
        params.message = message;
        params.contentType = 'text';
        onSend(params);
      }
      fileInputRef.current.value = "";
      setIsShowTempFile(false);

      setUpLoadFile(false);
      setRefValue([]);
    }
    return setMessage('');
  };
  const onDeleteFile = (index) => {
    if (refValue) {
      if (refValue.length == 1) {
        setIsShowTempFile(false);
        setRefValue([]);
        fileInputRef.current.value = "";
      } else {
        const newListFiles = Array.from(refValue).filter((file_current, i) => i != index);
        const dataTransfer = new DataTransfer();
        newListFiles.forEach(file => {
          dataTransfer.items.add(file);
        });
        setRefValue(dataTransfer.files)
      }
    }
  }
  const onHandleShowFileTemp = () => {
    if (fileInputRef.current.files.length > 0) {
      setRefValue(fileInputRef.current.files)
      setIsShowTempFile(true)
    } else {
      setIsShowTempFile(false);
      setRefValue([])
    }

  }

  return (
    <RootStyle>
      <Stack width={"100%"} direction={"column"} spacing={1}>
        {isShowTempFile ? <Stack width={"100%"} direction={"row"} spacing={1}>
          {refValue?.length > 0 && Array.from(refValue).map((file, index) => {
            return (
              <Box key={index} component={Paper} display={"flex"} flexDirection={"column"} maxWidth={200} maxHeight={50}>
                <Chip avatar={<AttachFileIcon />} label={file.name} onDelete={() => onDeleteFile(index)}>  </Chip>
              </Box>
            )
          })}

        </Stack> : null}
        <Stack width={"100%"} direction={"row"}>
          <Input
            disabled={disabled}
            fullWidth
            value={message}
            disableUnderline
            onKeyUp={handleKeyUp}
            onChange={handleChangeMessage}
            placeholder="Type a message"
            startAdornment={
              <InputAdornment position="start">
                <EmojiPicker disabled={disabled} value={message} setValue={setMessage} />
              </InputAdornment>
            }
            endAdornment={
              <Stack direction="row" spacing={0.5} mr={1.5}>
                <IconButton disabled={disabled} size="small" onClick={handleAttach}>
                  <Icon icon={roundAddPhotoAlternate} width={24} height={24} />
                </IconButton>
                <IconButton disabled={disabled} size="small" onClick={handleAttach}>
                  <Icon icon={attach2Fill} width={24} height={24} />
                </IconButton>
                <IconButton disabled={disabled} size="small">
                  <Icon icon={micFill} width={24} height={24} />
                </IconButton>
              </Stack>
            }
            sx={{ height: '100%' }}
          />

          <Divider orientation="vertical" flexItem />

          <IconButton color="primary" disabled={message != "" || updateLoadFile ? false : true} onClick={handleSend} sx={{ mx: 1 }}>
            <Icon icon={roundSend} width={24} height={24} />
          </IconButton>

          <input multiple type="file" ref={fileInputRef} onChange={() => onHandleShowFileTemp()} style={{ display: 'none' }} />
        </Stack>
      </Stack>
    </RootStyle>
  );
}
